<template>
<div class="content">
  <el-tabs class="tabLv3" type="border-card" v-model="tabName"><i class="lt"></i><i class="rt"></i>
    <el-tab-pane name="xjrwgl">
      <span slot="label"><i class="iconfont iconcheck"></i><i class="border"></i> 状态监测 </span>
      <normalNav :parent="self">
      </normalNav>
      <div class="searchForm1">
         <searchForm
            :items="items"
            :formPlus="seefrom"
            ref="searchForm_xjrwgl"
          >
            <template slot="last" ref="table_xjrwgl">
              <el-form-item label="应用系统" prop="system_id">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.system_id"
                  placeholder="请选择应用系统"
                  @change="selectDeviceType"
                >
                  <el-option
                    v-for="item in systemArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select
                  :popper-append-to-body="false"
                  placeholder="请输入设备类型"
                  v-model="seefrom.deviceType"
                  @change="selectEquipment"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备">
                <el-select
                  :popper-append-to-body="false"
                  placeholder=""
                  v-model="seefrom.equipment"
                >
                  <el-option
                    v-for="item in equipment"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
      </div>

      <div class="statusMain">
        <div class="left">
          <div v-if="listData!=null">
            <div v-for="(i,index) in list" :key="index" >
            {{i.name}}:{{listData[i.prop]}}
          </div>
          <div class="text" v-for="(i,index) in device_Info" :key="index">
            <span>{{i.dataflowName}}:{{i.dataflowData}}:{{i.dataflowUnit}}</span> 
          </div>
          </div>
          
        </div>
        <div class="right">
          <div v-if="listData!=null"><echarts :data='listData.lastWeek' className="lastWeek"></echarts></div>
          <div v-if="listData!=null"><echarts :data='listData.lastMonth' className="lastMonth"></echarts></div>
          <div v-if="listData!=null"><echarts :data='listData.lastTen' className="lastTen"></echarts></div>
          <div v-if="listData!=null"><echarts :data='listData.eachMonth' className="eachMonth"></echarts></div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import {
  obj2urlsp,
  descriptor
} from "utils";
export default {
  data() {
    return {
      tabName: 'xjrwgl',
      form_xjrwgl: {},
      list:[{name:'设备名称',prop:'deviceName'},{name:'设备编码',prop:'deviceId'},
      {name:'协议类型',prop:'protocolType'},{name:'设备状态',prop:'deviceStatusName'},
      {name:'离线次数',prop:'offlineCount'},{name:'数据流个数',prop:'dataFlowCount'}],
      listData:null,
      systemArr:[],//应用系统
      options:[],//设备类型
      equipment:[],//设备
      seefrom:{
        system_id:'',
        deviceType:'',
        equipment:''
      },
      items:[],
      other: {},
      device_Info:[]
    };
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    echarts: () => import("./echarts"),
  },
  watch:{
  },
  computed: {
    self() {
      return this;
    },
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.seefrom = {};
    },
    search_xjrwgl(fn) {
      this.listData=null
      fn();
    },
    getSys() {
      this.systemArr=[]
      // 应用系统
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
        {
          params: {
            compayId: localStorage.getItem("companyId"),
          },
        }
      ).then((res) => {
        res.data.data.forEach(i=>{
          this.systemArr.push({label:i.name,value:i.id})
        });
      });
    },
    selectDeviceType(){
      this.options=[]
      this.$axiosget("manager/operatingSystemApi/getDeviceTypeByOperatingId", {
          params: {
            id: this.seefrom.system_id,
          },
        }).then((res) => {
          res.data.data.forEach(i=>{
          this.options.push({label:i.typeName,value:i.id})
          });
        });
    },
    selectEquipment(){
      this.equipment=[]
      this.$axiosget("operation/device/list", {
        params: {
          ...this.seefrom,
          pageSize: 9999
        }
        }).then((res) => {     
          res.data.data.deviceList.forEach(i=>{
          this.equipment.push({label:i.deviceName,value:i.deviceId})
          });
        })
    },
    getData(){
      this.$axiosget("operation/deviceMonitorLog/deviceInfo",{
        params: {
          deviceId:this.seefrom.equipment
        }
      }).then(res=>{
        this.listData=res.data.data
        this.deviceInfo()
      })
    },
    deviceInfo(e) {
      this.$axiosget(
        "taos/taosdata/query_latest?id=" + this.listData.id + "&typeId=" +this.listData.deviceType
      ).then((res) => {
        this.device_Info=res.data.data
      });

    } 
  },
  
  mounted() {
    this.getSys()
  }
};
</script>

<style lang="less" scoped>
.statusMain{
  display: flex;
  color: #fff;
  font-size: 16px;
  .left{
    width: 400px;
    height: 600px;
    padding: 20px 60px;
    overflow-y: scroll;
    div>div{
      margin: 10px 0;
    }
    .text{
      margin: 60px 0;
      display: flex;
      flex-direction: column;
    }
  }
  .right{
    width: 1433px;
    height: 600px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    >div{
      width: 50%;
      height: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/statusDetection/index.vue